import { render, staticRenderFns } from "./isNoInfo.vue?vue&type=template&id=2823d64e&scoped=true"
import script from "./isNoInfo.vue?vue&type=script&lang=js"
export * from "./isNoInfo.vue?vue&type=script&lang=js"
import style0 from "./isNoInfo.vue?vue&type=style&index=0&id=2823d64e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2823d64e",
  null
  
)

export default component.exports